/* eslint-disable import/prefer-default-export */
// eventName: https://developers.google.com/tag-platform/gtagjs/reference/events

export const trackCustomEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, params);
  }
};

export const trackClickLink = ({ sectionName, linkTo }) => {
  trackCustomEvent('click_link', { sectionName, linkTo });
};
